<template>
    <div>
        <el-input 
            class="search" 
            type="text" 
            @change="updateList" 
            @input="updateList" 
            v-model="search"
            placeholder="Filter"
            prefix-icon="el-icon-search"/>
    </div>
</template>

<script>
    export default {
        name: 'Filters',
        props: ['tableData', 'fields'],
        data () {
            return {
                search: undefined,
                unfilteredList: undefined
            }
        },
        computed: {
            filteredList () {
                let fields = this.fields                
                let matcher = new RegExp(this.search, 'i')
                return this.unfilteredList.filter(function(data){
                    for (let field of fields) {
                        if (matcher.test(data[field]))
                        return matcher.test(data[field])
                        else if (typeof(field) === 'object') {
                            if (matcher.test(data[field[0]][field[1]]))
                                return matcher.test(data[field[0]][field[1]])
                        }
                    }    
                })
            }
        },
        async created () {
            this.unfilteredList = await this.tableData
            
        },
        watch: {
          tableData () {
              this.unfilteredList = this.tableData
          }
        },
        methods: {
            updateList () {
                this.$emit('filtered-list', this.filteredList);
            }
        }
        
    }
</script>

<style scoped>
    .el-input__inner {
        border: 1px solid white !important;
        border-radius: 4px;
    }
    .search {
        width: 60vw;
        max-width: 400px;
        border: none;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.05);
        border-width: 1px;
        border-color: var(--white);
        /* border-radius:  */
    }

    /* .search:active {
        box-shadow: 0 2px 4px 0 #409EFF;
    } */
</style>



// WEBPACK FOOTER //
// src/components/Filters/Filter.vue